import React, { useRef } from 'react';
import { Switch, useRouteMatch } from 'react-router-dom';
import PrivateRoute from '../../components/shared/PrivateRoute';
import DashboardLayout from '../../layouts/DashoardLayout';
import { Box, Paper } from '../../ui/core';
import { flushPageSx, surfaceCardSx } from '../../ui/styles';

import TripsDaily from './TripsDaily';
import TripsSatellite from './TripsSatellite';
import TripsStatusRail from '../../components/widgets/Trips/TripsStatusRail';
import { useTripsSubscription, useDriverLocationSub, useQuery } from '../../hooks';

const TripsShell = () => {
  useTripsSubscription();
  useDriverLocationSub();
  // The status rail belongs to the daily grouped table only — the satellite
  // route is a map with no status sections to scroll to.
  const isDailyRoute = !!useRouteMatch({ path: '/trips/daily' });
  // ...and to the list view of it: the map view has no sections either.
  const mapView = useQuery().view === 'map';
  // Scopes the status rail's DOM queries to this shell's subtree (its grid),
  // instead of a global document query.
  const shellRef = useRef(null);

  return (
    <Box sx={flushPageSx} ref={shellRef}>
      {isDailyRoute && !mapView && <TripsStatusRail scopeRef={shellRef} />}
      <Paper
        elevation={0}
        sx={{
          ...surfaceCardSx,
          flex: 1,
          minWidth: 0,
          // surfaceCardSx clips to the card's rounded corners, which also makes the
          // card a scrollport — and a sticky element's offsets resolve against its
          // nearest scrollport, so the mobile list's sticky status headers would pin
          // to a box that never scrolls and simply stop moving. On mobile the
          // document is the scroller, so the clip has to go. Nothing here reaches the
          // corners (the toolbar and the trip cards are both transparent), so there
          // is nothing left to clip.
          overflow: { xs: 'visible', md: 'hidden' },
        }}
      >
        <Switch>
          <PrivateRoute exact path="/trips/daily" component={TripsDaily} />
          <PrivateRoute exact path="/trips/satellite" component={TripsSatellite} />
        </Switch>
      </Paper>
    </Box>
  );
};

const Trips = () => (
  <DashboardLayout flush title="Trips">
    <TripsShell />
  </DashboardLayout>
);

export default Trips;
